import { cloneDeep } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { RosAndPe } from "../../encounter-constant";

export interface UseImportItemsResult {
  items: RosAndPe[] | null;
  setItems: (items: RosAndPe[] | null) => void;
  handleSelect: (index: number) => void;
  onDescriptionChange: (value: string, index: number) => void;
}

export const useImportItems = (): UseImportItemsResult => {
  const [items, setItems] = useState<RosAndPe[] | null>(null);

  const handleSelect = useCallback((index: number) => {
    setItems((prev) => {
      const copied = cloneDeep(prev);
      if (!copied) return prev;
      copied[index].isSelected = !copied[index].isSelected;
      return copied;
    });
  }, []);

  const onDescriptionChange = useCallback((value: string, index: number) => {
    setItems((prev) => {
      const copied = cloneDeep(prev);
      if (!copied) return prev;
      copied[index].description = value;
      return copied;
    });
  }, []);

  return useMemo(
    () => ({ items, setItems, handleSelect, onDescriptionChange }),
    [items, handleSelect, onDescriptionChange]
  );
};
